/**
 *  @module geo/functionalities
 */


import {Observable} from 'rxjs/Observable';
import {isUndefined} from 'util';

import {FilterValue} from '../types/functionality';

import {Functionality} from '.';
import {GeometryModificationFunctionalityService} from './services/geometry.modification';

/**
 * Execution parameters for geometry modification
 */
export interface GeometryModificationExecutionParameters {
  /**
   * filter to apply on geometrymodification execution
   */
  filters: FilterValue[];
  /**
   * describe selected filters
   */
  filtersLabel: string;
  /**
   * mark edition layer as requiring frequent rendering updates
   */
  animated: boolean;
  /**
   * mark edition layer as hosting a schema
   */
  schema: boolean;
  /**
   * fetch attributes of objects ('true' or 'false')
   */
  fetchAttributes: string;
}

/**
 * Accessor for geometry modification functionality.
 * 
 *  For instance:
 *
 *
 * to start edition on geometry modification :
 *
 * ```javascript
 *    geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute({});
 * ```
 *
 * 
 * to execute modification with specific parameters :
 * 
 * ```javascript
 *    geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute({
 *       "filters":
 *             [
 *               {"name":"rowidsupp","values":[300]},
 *               {"name":"rowidinf","values":[350]}
 *             ]
 *    });
 * ```
 */
export class GeometryModificationFunctionality extends Functionality {

  getService(): GeometryModificationFunctionalityService {
    if (isUndefined(this.store)) {
      throw new Error('no store defined for functionality');
    }
    if (!this.service) {
      const options = {
        store: this.store
      }

                      this.service =
          new GeometryModificationFunctionalityService(this, options);
    }
    return this.service;
  }


  static typeDef = 'com.bg.functionality.geometrymodification.GeometryModification';

  /**
   * Execute geometry modification
   *
   * - to open new geometry modification
   * ```
   * geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute();
   * ```
   *
   * @param parameters
   * @returns {Observable<any>}
   * @since v2.0.2
   */
  public execute(parameters: GeometryModificationExecutionParameters):
      Observable<any> {
    return super.execute(parameters);
  }
}


